export default "__VITE_ASSET__n7rXbTMY__"